import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

export default class CreateGroupModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    
    // 表单字段
    this.name = Stream('');
    this.reason = Stream('');
    this.description = Stream('');
    this.privacy = Stream('public');
    this.parent_id = Stream(null);
    this.contact = Stream('');
    this.is_container = Stream(false);
    this.cover_image = Stream('');
    
    // 状态
    this.loading = false;
    this.error = null;
    this.uploading = false; // 上传状态
    this.uploadProgress = 0; // 上传进度
    
    // 加载父群组列表
    this.parentGroups = [];
    this.loadParentGroups();
  }

  className() {
    return 'CreateGroupModal Modal--small';
  }

  title() {
    return app.translator.trans('tf-groups.forum.create-group-modal.title');
  }

  async loadParentGroups() {
    try {
      const response = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/social-groups',
        params: {
          filter: { is_container: true }
        }
      });
      
      if (response && response.data) {
        this.parentGroups = response.data;
      }
    } catch (error) {
      console.error('Error loading parent groups:', error);
    }
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form-group">
          <label className="Form-label">
            {app.translator.trans('tf-groups.forum.create-group-modal.fields.name.label')} *
          </label>
          <input 
            className="FormControl" 
            type="text" 
            value={this.name()}
            oninput={(e) => this.name(e.target.value)}
            placeholder={app.translator.trans('tf-groups.forum.create-group-modal.fields.name.placeholder')}
            required
          />
        </div>

        <div className="Form-group">
          <label className="Form-label">
            {app.translator.trans('tf-groups.forum.create-group-modal.fields.reason.label')} *
          </label>
          <textarea 
            className="FormControl" 
            rows="3"
            value={this.reason()}
            oninput={(e) => this.reason(e.target.value)}
            placeholder={app.translator.trans('tf-groups.forum.create-group-modal.fields.reason.placeholder')}
            required
          />
        </div>

        <div className="Form-group">
          <label className="Form-label">
            {app.translator.trans('tf-groups.forum.create-group-modal.fields.description.label')}
          </label>
          <textarea 
            className="FormControl" 
            rows="3"
            value={this.description()}
            oninput={(e) => this.description(e.target.value)}
            placeholder={app.translator.trans('tf-groups.forum.create-group-modal.fields.description.placeholder')}
          />
        </div>

        <div className="Form-group">
          <label className="Form-label">
            {app.translator.trans('tf-groups.forum.create-group-modal.fields.privacy.label')}
          </label>
          <select 
            className="FormControl" 
            value={this.privacy()}
            onchange={(e) => this.privacy(e.target.value)}
          >
            <option value="public">
              {app.translator.trans('tf-groups.forum.create-group-modal.fields.privacy.options.public')}
            </option>
            <option value="private">
              {app.translator.trans('tf-groups.forum.create-group-modal.fields.privacy.options.private')}
            </option>
          </select>
        </div>

        <div className="Form-group">
          <label className="Form-label" style="display: flex; align-items: center; cursor: pointer;">
            <input
              type="checkbox"
              checked={this.is_container()}
              onchange={(e) => {
                const checked = e.target.checked;
                this.is_container(checked);
                // 如果勾选容器群组，清空父群组选择（容器群组不能有父群组）
                if (checked && this.parent_id()) {
                  this.parent_id(null);
                }
                m.redraw();
              }}
              disabled={!!this.parent_id()}
              style="margin-right: 8px; cursor: pointer;"
            />
            <span>
              {app.translator.trans('tf-groups.forum.create-group-modal.fields.group-type.container')}
            </span>
          </label>
          <div className="Form-help">
            {app.translator.trans('tf-groups.forum.create-group-modal.fields.group-type.help')}
            {this.parent_id() && (
              <span style="color: #d32f2f; margin-left: 8px;">
                {app.translator.trans('tf-groups.forum.create-group-modal.fields.group-type.cannot-be-container')}
              </span>
            )}
          </div>
        </div>

        {!this.is_container() && (
          <div className="Form-group">
            <label className="Form-label">
              {app.translator.trans('tf-groups.forum.create-group-modal.fields.parent-group.label')}
            </label>
            <select 
              className="FormControl" 
              value={this.parent_id() || ''}
              onchange={(e) => {
                const parentId = e.target.value || null;
                this.parent_id(parentId);
                // 如果选择了父群组，自动取消勾选容器群组（有父群组的群组不能成为容器群组）
                if (parentId && this.is_container()) {
                  this.is_container(false);
                }
                m.redraw();
              }}
            >
              <option value="">
                {app.translator.trans('tf-groups.forum.create-group-modal.fields.parent-group.no-parent')}
              </option>
            {this.parentGroups
              .filter(group => group.is_container)
              .map(group => (
                <option key={group.id} value={group.id}>
                  {group.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="Form-group">
          <label className="Form-label">
            {app.translator.trans('tf-groups.forum.create-group-modal.fields.contact.label')} *
          </label>
          <input 
            className="FormControl" 
            type="tel" 
            value={this.contact()}
            oninput={(e) => this.contact(e.target.value)}
            placeholder={app.translator.trans('tf-groups.forum.create-group-modal.fields.contact.placeholder')}
            pattern="[\d\s\-\+\(\)]+"
            required
          />
        </div>

        <div className="Form-group">
          <label className="Form-label">
            {app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.label')}
          </label>
          <div className="CoverImageUpload">
            <input
              type="file"
              id="coverImageInput"
              accept="image/*"
              style="display: none;"
              onchange={(e) => this.handleFileSelect(e)}
            />
            <div className="UploadArea">
              {this.cover_image() ? (
                <div className="ImagePreview">
                  <img 
                    src={this.cover_image()} 
                    style="max-width: 200px; max-height: 150px; border-radius: 4px;"
                    onerror="this.style.display='none'"
                  />
                  <div className="ImageActions">
                    <Button
                      className="Button Button--primary Button--small"
                      onclick={() => document.getElementById('coverImageInput').click()}
                      disabled={this.uploading}
                    >
                      {app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.change-button')}
                    </Button>
                    <Button
                      className="Button Button--danger Button--small"
                      onclick={() => this.removeCoverImage()}
                      disabled={this.uploading}
                    >
                      {app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.remove-button')}
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="UploadPlaceholder">
                  <Button
                    className="Button Button--primary"
                    onclick={() => document.getElementById('coverImageInput').click()}
                    disabled={this.uploading}
                  >
                    {this.uploading 
                      ? app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.uploading')
                      : app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.select-button')
                    }
                  </Button>
                  <div className="Form-help">
                    {app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.upload-help')}
                  </div>
                </div>
              )}
            </div>
            {this.uploading && (
              <div className="UploadProgress">
                <div className="ProgressBar">
                  <div 
                    className="ProgressBar-fill" 
                    style={`width: ${this.uploadProgress}%`}
                  ></div>
                </div>
                <div className="ProgressText">{this.uploadProgress}%</div>
              </div>
            )}
          </div>
        </div>

        {this.error && (
          <div className="Form-group">
            <div className="Alert Alert--error">
              {this.error}
            </div>
          </div>
        )}

        {/* 操作按钮直接放在content内 */}
        <div className="Modal-actions">
          <Button 
            className="Button Button--primary" 
            onclick={() => this.submit()}
            loading={this.loading}
            disabled={this.loading}
          >
            {app.translator.trans('tf-groups.forum.create-group-modal.buttons.submit')}
          </Button>
          <Button 
            className="Button" 
            onclick={() => this.hide()}
            disabled={this.loading}
          >
            {app.translator.trans('tf-groups.forum.create-group-modal.buttons.cancel')}
          </Button>
        </div>
      </div>
    );
  }


  // 处理文件选择
  handleFileSelect(event) {
    const file = event.target.files[0];
    if (!file) return;

    // 验证文件类型
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      app.alerts.show(
        { type: 'error' },
        app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.invalid-format')
      );
      return;
    }

    // 验证文件大小 (5MB)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      app.alerts.show(
        { type: 'error' },
        app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.file-too-large')
      );
      return;
    }

    // 开始上传
    this.uploadFile(file);
  }

  // 上传文件
  uploadFile(file) {
    this.uploading = true;
    this.uploadProgress = 0;
    m.redraw();

    // 创建FormData
    const formData = new FormData();
    formData.append('image', file);

    // 发送上传请求
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/social-groups/upload',
      body: formData,
      // 注意：不要设置Content-Type，让浏览器自动设置multipart/form-data
      headers: {},
      // 模拟上传进度
      onprogress: (event) => {
        if (event.lengthComputable) {
          this.uploadProgress = Math.round((event.loaded / event.total) * 100);
          m.redraw();
        }
      }
    }).then(response => {
      if (response.success && response.path) {
        // 设置封面图片路径
        this.cover_image(response.path);
        app.alerts.show(
          { type: 'success' },
          app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.upload-success')
        );
      } else {
        throw new Error('上传响应格式错误');
      }
    }).catch(error => {
      console.error('文件上传失败:', error);
      let errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.upload-error');
      
      if (error.response && error.response.data) {
        if (error.response.data.error === 'forbidden') {
          errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.forbidden');
        } else if (error.response.data.error === 'no_file_uploaded') {
          errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.no-file');
        } else if (error.response.data.error === 'upload_failed') {
          errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.upload-error');
        } else if (error.response.data.error === 'invalid_file_type') {
          errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.invalid-type');
        } else if (error.response.data.error === 'file_too_large') {
          errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.size-exceeded');
        } else if (error.response.data.error === 'directory_creation_failed') {
          errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.directory-failed');
        } else if (error.response.data.error === 'file_save_failed') {
          errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.save-failed');
        } else if (error.response.data.error) {
          errorMessage = app.translator.trans('tf-groups.forum.create-group-modal.fields.cover-image.upload-error-prefix') + ': ' + error.response.data.error;
        }
      }
      
      app.alerts.show(
        { type: 'error' },
        errorMessage
      );
    }).finally(() => {
      this.uploading = false;
      this.uploadProgress = 0;
      m.redraw();
    });
  }

  // 删除封面图片
  removeCoverImage() {
    this.cover_image('');
    // 清空文件输入
    const fileInput = document.getElementById('coverImageInput');
    if (fileInput) {
      fileInput.value = '';
    }
    m.redraw();
  }

  async submit() {
    // 验证必填字段
    if (!this.name().trim()) {
      this.error = app.translator.trans('tf-groups.forum.create-group-modal.validation.name-required');
      m.redraw();
      return;
    }

    if (!this.reason().trim()) {
      this.error = app.translator.trans('tf-groups.forum.create-group-modal.validation.reason-required');
      m.redraw();
      return;
    }

    if (!this.contact().trim()) {
      this.error = app.translator.trans('tf-groups.forum.create-group-modal.validation.contact-required');
      m.redraw();
      return;
    }

    // 验证电话号码格式（支持数字、空格、连字符、加号、括号）
    const phoneRegex = /^[\d\s\-\+\(\)]+$/;
    const phoneNumber = this.contact().trim();
    // 移除所有非数字字符进行长度验证（至少7位，最多20位）
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    if (!phoneRegex.test(phoneNumber) || digitsOnly.length < 7 || digitsOnly.length > 20) {
      this.error = app.translator.trans('tf-groups.forum.create-group-modal.validation.contact-invalid');
      m.redraw();
      return;
    }

    this.loading = true;
    this.error = null;
    m.redraw();

    try {
      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/social-groups/apply',
        body: {
          name: this.name().trim(),
          reason: this.reason().trim(),
          description: this.description().trim(),
          privacy: this.privacy(),
          parent_id: this.parent_id(),
          contact: this.contact().trim(),
          is_container: this.is_container(),
          cover_image: this.cover_image() ? this.cover_image().trim() : null
        }
      });

      // 显示成功消息
      app.alerts.show(
        { type: 'success' },
        app.translator.trans('tf-groups.forum.create-group-modal.messages.success')
      );

      // 关闭模态框
      this.hide();

    } catch (error) {
      console.error('Error submitting group application:', error);
      this.error = error.response?.data?.error || app.translator.trans('tf-groups.forum.create-group-modal.messages.error');
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
}

